var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_1254",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_1254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_circle_2",
    d: "M14.6327 22.1327L24.0327 12.7327L22.166 10.866L14.6327 18.3993L10.8327 14.5993L8.96602 16.466L14.6327 22.1327ZM16.4993 29.3327C14.6549 29.3327 12.9216 28.9827 11.2993 28.2827C9.67713 27.5827 8.26602 26.6327 7.06602 25.4327C5.86602 24.2327 4.91602 22.8216 4.21602 21.1993C3.51602 19.5771 3.16602 17.8438 3.16602 15.9993C3.16602 14.1549 3.51602 12.4216 4.21602 10.7993C4.91602 9.17713 5.86602 7.76602 7.06602 6.56602C8.26602 5.36602 9.67713 4.41602 11.2993 3.71602C12.9216 3.01602 14.6549 2.66602 16.4993 2.66602C18.3438 2.66602 20.0771 3.01602 21.6993 3.71602C23.3216 4.41602 24.7327 5.36602 25.9327 6.56602C27.1327 7.76602 28.0827 9.17713 28.7827 10.7993C29.4827 12.4216 29.8327 14.1549 29.8327 15.9993C29.8327 17.8438 29.4827 19.5771 28.7827 21.1993C28.0827 22.8216 27.1327 24.2327 25.9327 25.4327C24.7327 26.6327 23.3216 27.5827 21.6993 28.2827C20.0771 28.9827 18.3438 29.3327 16.4993 29.3327Z",
    fill: "#00AC47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.89c8d3809207368f1bfea6bf6f5cb921.svg";
export { ForwardRef as ReactComponent };